/** English URL slug -> Bangla category name (must match values in BN_POSTS). */
export const BN_CATEGORY_SLUGS: Record<string, string> = {
  "digital-marketing": "ডিজিটাল মার্কেটিং",
  seo: "এসইও",
  "social-media": "সোশ্যাল মিডিয়া",
  freelancing: "ফ্রিল্যান্সিং",
  "paid-ads": "পেইড অ্যাডস",
  "content-marketing": "কন্টেন্ট মার্কেটিং",
  "email-marketing": "ইমেইল মার্কেটিং",
  ecommerce: "ই-কমার্স",
  "local-seo": "লোকাল SEO",
  aeo: "এআই সার্চ (AEO)",
};

/** Reverse lookup: Bangla category name -> URL slug. */
export function bnCategoryToSlug(name: string): string | null {
  const entry = Object.entries(BN_CATEGORY_SLUGS).find(([, n]) => n === name);
  return entry ? entry[0] : null;
}
